import { desktopMediaQueryString, mediumScreenMediaQueryString } from './breakpoints'

export default `

/* Desktop -- this must come BEFORE the tablet styles because there is some overlap in the media query */
@media only screen and ${desktopMediaQueryString} {
    .is-eligible-for-upgrade .page-layout:not(.has-hero-image):not(.full-height) {
        padding-top: 32px; /* For nav promotion */
    }
}

/* Tablet -- this must come AFTER the desktop styles because there is some overlap in the media query */
@media only screen and ${mediumScreenMediaQueryString} {
    .is-eligible-for-upgrade .page-layout {
        padding-top: 32px;
    }
}
`
